import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { AuthService } from '../auth.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-current-opening',
  templateUrl: './current-opening.component.html',
  styleUrls: ['./current-opening.component.scss'],
})
export class CurrentOpeningComponent implements OnInit, OnDestroy {

  // careerForm: FormGroup;

  selectedFiles: File[] = [];
  token: string | undefined;
  captchaSubs: Subscription = null;

  panelOpenState = false;
  jds: any;

  selected: string = 'resume';

  constructor(
    private auth: AuthService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private toastr: ToastrService
  ) {
    this.token = undefined;
  }

  ngOnInit(): void {

    // this.careerForm = this.fb.group({

    //   firstName: ['', Validators.required],
    //   lastName: ['', Validators.required],

    //   email: ['', [
    //     Validators.required,
    //     Validators.email
    //   ]],

    //   mobile: ['', Validators.required],

    //   location: ['', Validators.required],

    //   experience: ['', Validators.required],

    //   skills: ['', [ Validators.required,  Validators.maxLength(5)]],

    //   qualification: ['', Validators.required],
       
    //   noticePeriod:  ['', Validators.required],

    //   currentCtc: ['', Validators.required],

    //   expectedCtc: ['', Validators.required],

    //   recaptcha: ['']

    // });

    this.jobDescrption();
  }

  selectFiles(event: any): void {
    this.selectedFiles = event.target.files;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    console.log(file);
  }

  ngOnDestroy(): void {
    if (this.captchaSubs != null) {
      this.captchaSubs.unsubscribe();
    }
  }

  submitCarrer() {

    // this.captchaSubs = this.reCaptchaV3Service
    //   .execute('importantAction')
    //   .subscribe((token: string) => {

    //     console.log(`Token Generated: ${token}`);

    //     this.careerForm.controls['recaptcha']
    //       .setValue(token);
    //   });

    // // if (
    // //   this.careerForm.invalid ||
    // //   this.selectedFiles.length < 1
    // // ) {

    // //   this.careerForm.markAllAsTouched();

    // //   console.log("Career Form", this.careerForm);
    // //   console.log("Selected File Length", this.selectedFiles.length);

    // //   return;
    // // }

    // let body = new FormData();

    // body.append("file", this.selectedFiles[0]);

    // body.append(
    //   "candidateDetails",
    //   JSON.stringify(this.careerForm.value)
    // );

    // this.spinner.show();

    // this.auth.careerApi(body).subscribe(

    //   (res: any) => {

    //     if (res.errorCode == "200") {

    //       this.toastr.success(
    //         "We will get back to you shortly",
    //         "Job Applied Successfully"
    //       );

    //       this.careerForm.reset();

    //     } else if (res.errorCode == "201") {

    //       this.toastr.success("", res.errorMsg);

    //     } else {

    //       this.toastr.error(
    //         "Please try again later",
    //         "Job Application Failed!"
    //       );
    //     }

    //     this.spinner.hide();

    //   },

    //   (err) => {

    //     this.spinner.hide();

    //     this.toastr.error(
    //       "Please try again later",
    //       "Something went wrong!"
    //     );
    //   }
    // );
  }

  jobDescrption() {

    this.auth.jdApi().subscribe((res: any) => {

      console.log(res);

      if (res?.errors?.errorCode == '0000') {

        res?.data?.jobPostingDetails?.forEach((val: any) => {

          val.applyUrl =
            `https://hungryforjob.com/hfj/online_candidate_form?job=${val.id}`;
            // `http://172.67.146.169/hfj/online_candidate_form?job=${val.id}`;
        });

        this.jds = res.data.jobPostingDetails;

        console.log("jds ======", this.jds);
      }
    });
  }

  getErrorMessage(controlName: string) {
    // const control = this.careerForm.get(controlName);

    // if (control?.hasError('required')) {
    //   return `${controlName} is required`;
    // }

    // if (control?.hasError('email')) {
    //   return 'Invalid email address';
    // }

    // return '';
  }



  
}